import { FC } from 'react';
import { Button, Spinner, OverlayTrigger, Popover } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  isLoading?: boolean;
  text?: string;
  titlePopOver?: string;
}

const styleButtonInfo = { marginLeft: 10, marginRight:10, backgroundColor: '#5F89B5', borderColor: '#5F89B5' }

const ButtonProgram: FC<IProps> = ({
  isLoading,
  text,
  titlePopOver
}) => {
  return (

    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={
        <Popover>
          <Popover.Body>
          {titlePopOver}
          </Popover.Body>
        </Popover>
      }>
        <Button
         style={styleButtonInfo}
         type="button" 
             
         >
         {isLoading &&
           <Spinner
             as="span"
             animation="border"
             size="sm"
             role="status"
             aria-hidden="true"
           />
         }
        {text}   
       </Button>
    </OverlayTrigger>
  );
}

export default ButtonProgram;